module.exports = __webpack_public_path__ + "img/section1-1-desktop.f7841fd6.png";